import React from 'react';
import { css } from 'aphrodite/no-important';
import styles from './AddTitle.styles';

const AddTitle = props => {
  if (!props.showData) {
    return <span>{props.default}</span>;
  }
  const renderField = (field, index) => {
    return (
      <div key={index} className={css(styles.field)}>
        <span className={css(styles.label)}>{field.name}</span>
        <span className={css(styles.value)}>{field.value}</span>
      </div>
    );
  };
  return (
    <div className={css(styles.fields)}>
      {props.data && props.data.map(renderField)}
    </div>
  );
};

export default AddTitle;



// WEBPACK FOOTER //
// ./src/components/forms/addtitle/AddTitle.js